import { request, requestJson } from '../common/http';
import type { DayOff } from './models';

// Days-off is its own top-level resource — one row per (member, date),
// addressed at `/days-off/{teamMemberId}[/{date}]`. The FE toggles
// individual days via PUT/DELETE on the dated path. No body, no OCC;
// the backend's writes are idempotent upsert/delete.
export const getDaysOff = (teamMemberId: string): Promise<{ items: DayOff[] }> =>
    requestJson<{ items: DayOff[] }>({
        method: 'GET',
        path: `/days-off/${encodeURIComponent(teamMemberId)}`,
    });

export const addDayOff = async (teamMemberId: string, date: string): Promise<void> => {
    await request<void>({
        method: 'PUT',
        path: `/days-off/${encodeURIComponent(teamMemberId)}/${encodeURIComponent(date)}`,
    });
};

export const removeDayOff = async (teamMemberId: string, date: string): Promise<void> => {
    await request<void>({
        method: 'DELETE',
        path: `/days-off/${encodeURIComponent(teamMemberId)}/${encodeURIComponent(date)}`,
    });
};
